<template>
  <div>
    <nav-bar ref="form"/>
    <div class="sec-garay-bg py-16 ">
      <div class="container sec-wight-bg border-radius ">
        <div class="row ">
          <h5 class="text-blue col py-0">
            <page-title :titles="'خدمات'"/>
          </h5>
        </div>
      </div>
      <div v-if="Services !== undefined && Services.length >0" class="container p-md-0">
        <div class="row reverseorder">
          <div class="col-12 col-md-4 " v-for="item in Services " :key="item.id">
            <router-link :to="{path:'servicesDetails',query:{ServiceDetailsId:item.id}}">
              <div class="card-bg border-radius py-4">
                <img class="d-block mx-auto" :src="$replaceHttps(item.imageUrl)" width="150" height="150">
                <div class="pt-10 text-center">{{ item.productName }}</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <footer-menu></footer-menu>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import FooterMenu from "@/components/footer";
import PageTitle from "@/components/titles";

export default {
  name: "servicesPage",
  components: {PageTitle, FooterMenu, NavBar},
  metaInfo: {
    title: 'ماشین سازان اصلانیان-خدمات'
  },
  data: () => ({
    showLoaderDialog: false,
    isPageLoaded: false,
    Services: [],
  }),

  mounted() {
    this.getData()
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/Services", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.isPageLoaded = true
            let json = JSON.parse(result)

            this.Services = json.filter(x => x.isActive === true)
            this.showLoaderDialog = false;
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>
.reverseorder {
  flex-direction: row-reverse;
}

</style>